export default __webpack_public_path__ + "static/media/address.c1d26453.svg";